// src/components/Header/Header.jsx

import React, { useState, useContext, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import menuData from '../../data/menu.json';
import DropDown from './DropDown';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { TranslationContext } from '../../contexts/TranslationContext';
import { BlogArticleContext } from '../../contexts/BlogArticleContext';
import EmbajadorButton from '../Button/EmbajadoresButton';
import { useTranslation } from 'react-i18next';

export const languages = [
  {
    code: 'en',
    name: 'Eng',
    flag: '/images/languages/united-kingdom_min.png',
    hreflang: 'en-GB',
  },
  {
    code: 'de',
    name: 'Ger',
    flag: '/images/languages/germany_min.png',
    hreflang: 'de-DE',
  },
  {
    code: 'en-au',
    name: 'Aus',
    flag: '/images/languages/australia_min.png',
    hreflang: 'en-AU',
  },
  {
    code: 'es',
    name: 'Col',
    flag: '/images/languages/colombia_min.png',
    hreflang: 'es-ES',
  },
  {
    code: 'fr',
    name: 'Fra',
    flag: '/images/languages/france_min.png',
    hreflang: 'fr-FR',
  },
  {
    code: 'it',
    name: 'Ita',
    flag: '/images/languages/italy_min.png',
    hreflang: 'it-IT',
  },
  {
    code: 'pt',
    name: 'Pt',
    flag: '/images/languages/portugal_min.png',
    hreflang: 'pt-PT',
  },
  {
    code: 'es-es',
    name: 'Esp',
    flag: '/images/languages/spain_min.png',
    hreflang: 'es-CO',
  },
];

const headerCSS = `

.cs_site_header {
  position: relative;
  z-index: 101;
}

.cs_site-branding {
  display: inline-block;
  max-width: 180px;
}
.cs_site_header {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0px;
  transition: all 0.4s ease;
}
.cs_toolbox {
  display: flex;
  gap: 45px;
  .cs_toolbox_btn {
    border: none;
    background-color: transparent;
    display: flex;
    padding: 0;
    cursor: pointer;
    transition: all 0.4s ease;
    &:hover {
      color: $accent;
    }
  }
}

// PARA OCULTAR EL MENU HAMBURGUESA

.mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .mobile-only {
    display: block;
  }
}
.cs_site_header.cs_style1 {
  .cs_main_header_in,
  .cs_top_header_in {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    height: 60px;
    position: relative;
    
  }
  .cs_main_header_right {
    display: flex;
    align-items: center;
    justify-content: flex-start; /* Asegura que los elementos se alineen hacia la izquierda */
    gap: 15px; /* Espaciado entre los elementos, ajustable */
  }
  &.cs_white_color {
    .cs_toolbox {
      color: $primary;
    }

    @media (max-width: 1199px) {
      .cs_nav .cs_nav_list {
        color: #fff;
        background-color: $primary;
      }
      .cs_menu_toggle.cs_toggle_active {
        color: #fff;
      }
    }
  }

  
  &.cs_gescout_sticky {
    &.cs_white_color {
      .cs_toolbox {
        color: #fff;
      }
      .cs_menu_toggle:not(.cs_toggle_active) span {
        color: #fff;
      }
    }
  }
  &.cs_color_1 {
    .cs_toolbox_btn {
      color: #fff;
    }
    .cs_menu_toggle {
      color: #fff;
    }
  }
}

.cs_site_header.cs_style1 {
  &.cs_sticky_active {
    background-color: $white;
    box-shadow: 0 10px 10px -10px rgba(33, 43, 53, 0.1);
  }

  .cs_action_box {
    display: flex;
    align-items: center;
    .cs_action_value {
      margin-left: 15px;
    }
    > * {
      &:not(:last-child) {
        margin-right: 35px;
      }
    }
  }
}

.cs_site_header_full_width .container {
  max-width: 100%;
  padding: 0 100px;
}

.cs_site_header_style1 {
  border-bottom: 1px solid #1a188d;

  .cs_main_header_right {
    display: flex;
    align-items: center;
  }

  .cs_nav + .cs_header_toolbox.cs_center {
    margin-left: 35px;
  }

  .cs_nav .cs_nav_list > li.current-menu-item > a:before {
    bottom: -4px;
    background-color: $white;
  }
}


.cs_sidenav {
  position: fixed;
  z-index: 1111;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
  transition: all 0.4s ease;
  opacity: 0;
  visibility: hidden;
  &.active {
    opacity: 1;
    visibility: visible;
  }
}

.cs_sidenav_overlay {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(11, 11, 11, 0.5);
  height: 100%;
  width: 100%;
  cursor: zoom-out;
}

.cs_sidenav_in {
  position: relative;
  z-index: 2;
  background-color: #fff;
  width: 100%;
  max-width: 620px;
  padding: 60px 80px;
  overflow-y: auto;
  overflow-x: hidden;
  hr {
    width: calc(100% + 80px);
  }
  .cs_newsletter.cs_style1 {
    .cs_newsletter_title {
      font-size: 28px;
      line-height: 1.35em;
      margin-bottom: 9px;
    }
  }
  .cs_social_links a {
    background-color: $primary;
    color: #fff;
    height: 30px;
    width: 30px;
    font-size: 14px;
    &:hover {
      background-color: $accent;
    }
  }
  .cs_close {
    margin-bottom: 52px;
  }
}
.cs_close {
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.4s ease;
  &:hover {
    transform: rotate(90deg);
  }
}
.cs_header_search {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease;
  &.active {
    opacity: 1;
    visibility: visible;
  }
}
.cs_header_search_in {
  position: relative;
  z-index: 1;
  background-color: #fff;
  padding: 50px 0;
  .cs_search_form {
    max-width: 100%;
    input {
      border-radius: 40px;
      padding: 10px 90px 10px 35px;
      font-size: 20px;
      height: 80px;
      @media (max-width: 575px) {
        padding: 10px 65px 10px 20px;
        font-size: 18px;
        height: 66px;
      }
    }
    .cs_search_btn {
      width: 80px;
      @media (max-width: 575px) {
        width: 60px;
      }
      svg {
        width: 28px;
        height: 28px;
        @media (max-width: 575px) {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
.cs_header_search_box {
  display: flex;
  align-items: center;
  gap: 0 30px;
  @media (max-width: 991px) {
    gap: 0 15px;
  }
}
@media screen and (max-width: 1199px) {
  .cs_main_header .container {
    max-width: 100%;
  }



  .cs_site_header.cs_style1 {
    .cs_nav {
      display: flex;
    }
  }
}

.cs_nav ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.cs_sticky_header {
  position: fixed !important;
  width: 100%;
  z-index: 999;
}
.cs_gescout_sticky {
  position: fixed !important;
  top: -110px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease;
  background-color: #fff;
  .cs_main_header_in {
    height: 90px;
  }
  &.cs_white_color {
    background-color: $primary;
  }
}




.cs_gescout_show {
  top: 0 !important;
  opacity: 1;
  visibility: visible;
  box-shadow: 0px 1px 2px 0px rgba(2, 0, 181, 0.1);
}

.cs_site_branding {
  display: inline-block;
}

@media screen and (min-width: 1200px) {
  .cs_site_header.cs_style1.cs_white_color {
    .menu-item-has-children {
      ul {
        // color: $primary;
        color: #4a4a49;
      }
    }
  }
  .cs_main_header {
    position: relative;
    
    .container-fluid {
      padding-right: 40px;
      padding-left: 40px;
    }
  }

  .cs_main_header_center,
  .cs_top_header_center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .cs_site_header.cs_style1 {
    .cs_main_header_center {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      max-width: calc(100% - 300px);
    }
    .cs_main_header_left {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
    }
  }

  .cs_nav {
    display: flex;
    align-items: center;
    height: 100%;
    line-height: 1.6em;

    .cs_nav_list {
      display: flex !important;
      flex-wrap: wrap;
      height: inherit;
   

      > li {
        margin-right: 20px;
        height: inherit;

        &:last-child {
          margin-right: 0;
        }

        > a {
          padding: 10px 0;
          display: inline-flex;
          position: relative;
          height: inherit;
          align-items: center;
        }

        > ul {
          left: 0;
          top: calc(100% + 15px);
        }

        &:hover {
          > ul {
            top: 100%;
            opacity: 1;
            visibility: visible;
            transition: all 0.4s ease;
          }
        }
        &.menu-item-has-children {
          > a {
            position: relative;
            &::after {
              content: '';
              display: inline-block;
              height: 6px;
              width: 6px;
              border: 2px solid currentColor;
              transform: rotate(45deg);
              border-left: 0;
              border-top: 0;
              margin-left: 6px;
              position: relative;
              top: -1px;
              border-radius: 0px 0px 2px 0px;
            }
          }
        }
      }
      

      li:not(.cs_mega_menu) {
        position: relative;
      }

      ul {
        width: 260px;
        background-color: #fff;
        position: absolute;
        box-shadow: 0px 1px 2px 0px rgba(2, 0, 181, 0.1);
        padding: 10px 0;
        z-index: 100;
        opacity: 0;
        visibility: hidden;
        display: block !important;
        border-radius: 15px;
        box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
        transition: all 0.1s ease;

        li {
          &:hover {
            ul {
              top: 0px;
            }

            > ul {
              opacity: 1;
              visibility: visible;
              transition: all 0.4s ease;
            }
          }
        }

        a {
          display: block;
          line-height: inherit;
          padding: 10px 20px;
        }

        ul {
          top: 15px;
          left: 100%;
        }
      }
    }
  }
  .cs_menu_toggle,
  .cs_munu_dropdown_toggle {
    display: none;
  }

  .cs_nav .cs_nav_list {
    .cs_mega_menu {
      position: relative;
    }
    .cs_mega_wrapper {
      width: 475px !important;
      left: 0;
      display: flex !important;
      position: absolute;
      padding: 5px 15px 10px;

      a {
        padding: 7px 10px;
      }

      > li {
        flex: 1;
        padding: 10px 0;

        > a {
          font-size: 18px;
          font-weight: 600;
          pointer-events: none;
          &:hover {
            background-color: transparent;
          }
        }

        ul {
          position: initial;
          border: none;
          padding: 0;
          width: 100%;
          box-shadow: none;
          background-color: transparent;
          a {
            transition: all 0.4s ease;
            &:hover {
              letter-spacing: 1px;
            }
          }
        }
      }
    }

    .cs_mega_menu {
      &:hover {
        .cs_mega_wrapper {
          li ul {
            opacity: 1;
            visibility: visible;
          }
        }
      }
    }
  }

  .cs_nav
    .cs_nav_list
    > li
    ul:not(.cs_mega_wrapper)
    .menu-item-has-children
    > a {
    position: relative;
  }
}

@media screen and (max-width: 1400px) {
  .cs_nav .cs_nav_list .cs_mega_wrapper {
    width: 1116px !important;
  }

  .cs_site-branding {
    max-width: 190px;
  }

  .cs_site_header_full_width .container {
    max-width: 100%;
  }
}

@media screen and (max-width: 1199px) {
  .cs_site_header.cs_style1.cs_mobile_toggle_active {
    background-color: #fff;
    &.cs_white_color {
      background-color: $primary;
    }
  }
  .cs_toolbox .cs_sidebar_toggle_btn {
    display: none;
  }
  .cs_site_header.cs_style1 .cs_main_header_right {
    padding-right: 40px;
  }
  .cs_toolbox .cs_toolbox_btn {
    max-width: 26px;
  }
  .cs_nav .cs_nav_list .cs_mega_wrapper {
    width: 100% !important;
  }
  .cs_site_header_full_width .container {
    padding: 0 15px;
  }
  .cs_munu_dropdown_toggle {
    position: absolute;
    height: 40px;
    width: 100%;
    top: 0;
    left: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 28px 18px;
    cursor: pointer;
    z-index: 3;

    span {
      display: block;
      position: relative;
      height: 10px;
      width: 10px;
      line-height: 1.2em;
      &:before,
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        height: 2px;
        width: 10px;
        background-color: currentColor;
        transition: all 0.3s ease;
      }

      &:before {
        transform: translate(-50%, -50%) rotate(90deg);
      }
    }

    &.active {
      span {
        &:before {
          transform: translate(-50%, -50%) rotate(0deg);
        }
      }
    }
  }
  .menu-item-has-children {
    .menu-item-has-children {
      .cs_munu_dropdown_toggle {
        padding: 20px 18px;
        
      }
    }
  }
  .cs_site_branding {
    position: relative;
    z-index: 101;
  }
  .cs_nav {
    .cs_nav_list {
      position: fixed;
      width: 100vw;
      left: -100vw;
      background-color: #fff;
      color: $primary;
      padding: 10px 0;
      top: 80px;
      overflow: auto;
      height: calc(100vh - 80px);
      line-height: 1.6em;
      transition: all 0.4s ease;
      &.cs_active {
        left: 0vw;
      }

      ul {
        padding-left: 10px;
        display: none;
      }

      a {
        display: block;
        padding: 12px 15px;
        line-height: 16px;
      }
      > li {
        > a {
          font-size: 18px;
          line-height: 1.4em;
        }
      }
    }

    .menu-item-has-children {
      position: relative;
      
    }
  }

  /*Mobile Menu Button*/
  .cs_menu_toggle {
    display: inline-block;
    width: 30px;
    height: 27px;
    cursor: pointer;
    position: absolute;
    top: 27px;
    right: 30px;
    color: $primary;

    span,
    span:before,
    span:after {
      width: 100%;
      height: 3px;
      background-color: currentColor;
      display: block;
      border-radius: 5px;
    }

    span {
      margin: 0 auto;
      position: relative;
      top: 12px;
      transition-duration: 0s;
      transition-delay: 0.2s;

      &:before {
        content: '';
        position: absolute;
        margin-top: -9px;
        transition-property: margin, transform;
        transition-duration: 0.2s;
        transition-delay: 0.2s, 0s;
      }

      &:after {
        content: '';
        position: absolute;
        margin-top: 9px;
        transition-property: margin, transform;
        transition-duration: 0.2s;
        transition-delay: 0.2s, 0s;
      }
    }
  }

  .cs_site_header.cs_style1 .cs_menu_toggle {
    top: 50%;
    right: 0px;
    margin-top: -13px;
  }

  .cs_toggle_active {
    span {
      background-color: rgba(0, 0, 0, 0);
      transition-delay: 0.2s;

      &:before {
        margin-top: 0;
        transform: rotate(45deg);
        transition-delay: 0s, 0.2s;
      }

      &:after {
        margin-top: 0;
        transform: rotate(-45deg);
        transition-delay: 0s, 0.2s;
      }
    }
  }

  .cs_nav .cs_nav_list a {
    position: relative;
  }

  .cs_site_header.cs_style1 .cs_main_header_in {
    height: 80px;
    width: 100%;
    
  }

  .cs_site_header .current-menu-item > a:before {
    display: none;
  }
  .cs_site_header.cs_style1 .cs_main_header_center {
    .cs_site_branding {
      position: absolute;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .cs_site_header.cs_style1 {
    top: 0;
  }

  .cs_has_main_nav {
    display: none;
  }
}

@media screen and (max-width: 991px) {
  .cs_site_header .container {
    max-width: 100%;
  }
  .cs_site_header.cs_style1 {
    .cs_action_box > *:not(:last-child) {
      margin-right: 25px;
    }
  }
}
@media screen and (max-width: 575px) {
  .cs_site-branding {
    max-width: 150px;
  }
}
/*Start Demo Menu*/
@media (min-width: 1200px) {
  .cs_nav .cs_nav_list > li > ul.cs_demo_mega {
    width: 1110px;
    display: flex !important;
    text-align: center;
    padding: 15px;
    left: 50%;
    transform: translateX(-50%);
    position: fixed;
    top: 100px;
    a {
      padding: 10px;
    }
    img {
      border-radius: 8px;
      box-shadow: 0px 3px 18px 1px rgba(48, 123, 196, 0.1);
      border: 1px solid rgba($primary, 0.06);
    }
    span {
      display: block;
      // font-weight: 500;
      margin-top: 6px;
      font-size: 90%;
      margin-bottom: -8px;
    }
    + ul {
      display: none !important;
    }
  }
}
@media (max-width: 1199px) {
  .cs_nav .cs_nav_list > li > ul.cs_demo_mega {
    display: none !important;
  }
}
/*End Demo Menu*/
.cs_site_header.cs_style1 {
  &.cs_color_2 {
    background-color: #fff;
  }
  .cs_btn.cs_style_1 {
    @media (max-width: 420px) {
      padding: 7px 15px;
      font-size: 14px;
      i {
        display: none;
      }
    }
    @media (max-width: 350px) {
      display: none;
    }
  }
}

.site-logo{
  height: 238px;
  width: 60px;
}

/* Asegúrate de que el LanguageSwitcher tenga un margen adecuado */
.language-switcher {
  margin-left: -10px; /* Ajusta el margen izquierdo para reducir la distancia */
  margin-right: 0; /* Elimina margen derecho si es necesario */

}

.language-switcher button {
  padding: 0; /* Elimina padding extra en el botón */
  margin: 0;  /* Elimina margen extra en el botón */
}

/* Opcional: Ajustar márgenes en los íconos del language switcher */
// .language-switcher img {
//   margin-right: 5px; /* Ajusta la distancia entre la bandera y el texto */
// }

/* Asegura que el menú desplegable no afecte el layout */
.language-switcher .dropdown-menu {
  position: absolute;
  margin-top: 2px; /* Ajusta la posición del menú si es necesario */
  padding: 0; /* Elimina relleno adicional */
} 

/* Línea blanca sobre el header */
.header-line {
  text-align: center;
  background-color: #ffffff40; /* Fondo transparente */
  display: flex;
  justify-content: center;
  gap: 50px; /* Ajusta el espacio entre los elementos */
  padding: 5px 15px; /* Espaciado interno */
  flex-wrap: wrap; /* Permite que los elementos se acomoden en varias líneas */
}

.phone-number {
  font-size: 14px;
  display: flex;
  gap: 5px;
  align-items: center;
  color: #4a4a49;
}

 .phone-number-text {
  color: #4a4a49;
 }

.phone-number .icon_header {
  font-size: 14px; /* Tamaño adecuado para iconos */
}
.phone-location {
  font-size: 0.6rem;
  color: WHITE;  /* Color más suave para diferenciarlo del número */
}

@media (max-width: 768px) {
  .phone-location {
    font-size: 0.3rem;
    color: white;  /* Color más suave para diferenciarlo del número */
  }
  .d-none.d-md-block {
    display: block;
  }
}
/* Estilos cuando el header es sticky */
.sticky-line {
  border-top: 1px solid rgba(255, 255, 255, 0.8); /* Borde sutil cuando es sticky */
}

/* Media Queries para Pantallas Pequeñas (Móviles) */
@media (max-width: 768px) {
  .language-switcher{
    margin-top: -8px;
  }
  /* Hacer que los elementos de contacto se apilen verticalmente */
  .header-line {
    display: flex;
    flex-direction:row;
    justify-content:center; /* Alinear al principio */
    gap: 5px; /* Espacio entre cada elemento */
    padding: 0.5px; /* Ajuste del padding */
  }

  .phone-number {
    font-size: 10px; /* Aumentar ligeramente el tamaño de la fuente */
    /* width: 100%; /* Asegurar que los números de teléfono ocupen todo el ancho */
    justify-content: center; /* Centrar los textos */
  }

  .phone-number .icon_header {
    font-size: 10px; /* Aumentar el tamaño de los iconos para la versión móvil */
  }
}

/* Estilo del botón "¿Quieres ser embajador?" */
.embajador-button-header {
  display: flex;
  margin-right: 10px; /* Agrega espacio entre el botón y otros elementos */
  padding: 1px 10px;
  color: white;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 50px;
  transition: background-color 0.3s ease;
  background-color: #C287C4;
}


.embajador-button-header:hover { /* Color verde oscuro al pasar el mouse */
  color:#4a4a49;
}

.embajador-list-item {
  margin-top: 10px; /* Espacio entre los elementos del menú y el botón */
}

/* En versión móvil */
.embajador-button-header {
  display: none;
  
}

.embajador-button-mobile {
  display: block;
  /* Color de texto predeterminado en móvil */
  color: #E866A2; /* Color predeterminado para móvil */
  font-weight: bold;
  font-size: 12px;
  padding: 8px 16px;
  margin-left: 5px;
}

/* En versión escritorio */
@media (min-width: 768px) {
  .embajador-button-header {
    display: block;
     /* Color de texto cuando se muestre en el menú desplegable */
  }

  .embajador-button-mobile {
    display: none;
  }
}


/* Aseguramos que el botón se vea bien en móviles */
@media (max-width: 768px) {
  .embajador-button-header {
    color: #E866A2;
    font-size: 12px;
    padding: 8px 16px;
    margin-left: 10px; /* Ajustar espacio en móviles */
  }
}

.cs_hero_icon_link {
  display: inline-block; /* Asegúrate de que el enlace sea un bloque en línea */
  transition: transform 0.3s ease; /* Añade una transición suave para un efecto visual */
}

.cs_hero_icon_link:hover {
  transform: scale(1.1); /* Aumentar ligeramente el tamaño del icono */
}
.cs_site_header.cs_style1.cs_active_sticky {
  background-color: #ffffff90;
  backdrop-filter: blur(30px);
  color: #4a4a49;
 
}
.cs_site_header.cs_style1.cs_active_sticky .phone-location {
  color: #4a4a49;
  font-weight:500;
}
.cs_site_header.cs_style1.cs_white_color.cs_active_sticky {
  background-color: #274760;
}
.cs_accent_bg .cs_social_links_wrap h2,
.cs_site_header.cs_style1.cs_white_color.cs_active_sticky .cs_toolbox {
  color: #fff;
}
.cs_contact_widget i {
  height: 20px;
  width: 20px;
  margin-top: 2px;
  color: #fff;
  padding: 4px;
}
.cs_video_open {
  cursor: pointer;
}
.cs_hero.cs_style_1 {
  .cs_text_btn_2,
  .cs_hero_title,
  .cs_hero_subtitle {
    position: relative;
    z-index: 1;
  }

  .cs_hero_text {
    position: initial;
    z-index: initial;
  }
}
.cs_accordian_body_wrap {
  overflow: hidden;
  transition: all 0.4s ease;
}
.cs_tabs.cs_style1 .cs_tab_links .cs_tab_link_in {
  cursor: pointer;
}
.cs_rating {
  i {
    display: flex;
  }
}

.cs_cs_slider_navigation_1 {
  .cs_slider_next,
  .cs_slider_prev {
    transition: all 0.4s ease;
    cursor: pointer;
    border-radius: 10px;
    padding: 5px;
    height: 60px;
    transform: translateY(-50%);
    background-color: #fff;
    width: 70px;
    box-shadow: 0px 4px 21px 1px rgba(48, 123, 196, 0.1);
    position: absolute;
    top: 50%;
    display: flex !important;
    z-index: 1;
    @media (min-width: 991px) {
      opacity: 0;
    }
  }
  .cs_slider_next {
    right: -35px;
  }
  .cs_slider_prev {
    left: -35px;
  }
  &:hover {
    .cs_slider_next,
    .cs_slider_prev {
      opacity: 1;
    }
  }
}
.cs_cs_slider_navigation_2 {
  .cs_slider_next,
  .cs_slider_prev {
    height: 40px;
    width: 40px;
    border: 2px solid $accent;
    border-radius: 50%;
    padding: 8px;
    transition: all 0.4s ease;
    cursor: pointer;
    position: absolute;
    display: flex !important;
    bottom: 0;
  }
  .cs_slider_next {
    right: 0;
  }
  .cs_slider_prev {
    right: 52px;
  }
}
.cs_cs_slider_navigation_3 {
  .cs_slider_next,
  .cs_slider_prev {
    width: 90px;
    height: 70px;
    background-color: #fff;
    border-radius: 10px;
    padding: 5px;
    transition: all 0.4s ease;
    cursor: pointer;
    display: flex !important;
    position: absolute;
    top: -213px;
    @media (max-width: 1700px) {
      width: 80px;
      height: 60px;
      top: -188px;
    }
    @media (max-width: 991px) {
      display: none !important;
    }
    img {
      transition: inherit;
    }
    &:hover {
      background-color: $accent;
      img {
        filter: brightness(0) invert(1);
      }
    }
  }
  .cs_slider_next {
    right: 0;
  }
  .cs_slider_prev {
    right: 115px;
    @media (max-width: 1700px) {
      right: 100px;
    }
  }
  .slick-dots {
    display: none !important;
    @media (max-width: 991px) {
      display: flex !important;
    }
  }
}
.cs_related_doctor {
  padding-bottom: 90px;
  @media (max-width: 400px) {
    padding-bottom: 75px;
  }
  .slick-dots {
    bottom: 15px;
  }
}
.cs_gallery_grid_1 {
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
    .cs_grid_item {
      &:nth-child(2) {
        display: none;
      }
    }
  }
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
  .cs_section_heading.cs_style_1 {
    min-height: 263px;
    @media (max-width: 1700px) {
      min-height: 166px;
    }
    @media (max-width: 991px) {
      min-height: initial;
    }
  }
  .cs_grid_item {
    &:first-child {
      grid-column: span 2;
    }
    @media (min-width: 992px) {
      &:nth-child(6) {
        grid-column: span 2;
      }
    }

    &:nth-child(5) {
      .cs_portfolio.cs_style_1 {
        height: 767px;
        margin-top: -338px;
        @media (max-width: 1700px) {
          height: 590px;
          margin-top: -240px;
        }
        @media (max-width: 991px) {
          margin-top: 0;
          height: 400px;
        }
      }
      @media (max-width: 991px) {
        grid-column: span 2;
      }
      @media (max-width: 767px) {
        grid-column: initial;
      }
    }
  }
  @media (max-width: 1700px) {
    .cs_portfolio.cs_style_1 {
      height: 350px;
    }
  }
}
.cs_gallery_grid_2 {
  display: grid;
  grid-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 25px 0px;
  }

  .cs_grid_item {
    @media (min-width: 768px) {
      &:first-child {
        grid-column: span 2;
      }
    }

    @media (min-width: 992px) {
      &:nth-child(7) {
        grid-column: span 2;
      }
    }
  }
  @media (max-width: 1700px) {
    .cs_portfolio.cs_style_1 {
      height: 350px;
    }
  }
  @media (max-width: 420px) {
    .cs_portfolio.cs_style_1 {
      height: 300px;
    }
  }
}
.cs_portfolio.cs_style_1 .cs_portfolio_img > div > img {
  cursor: zoom-in;
  height: 100%;
  left: 0;
  -o-object-fit: cover;
  object-fit: cover;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 5;
}
.cs_team_grid {
  display: grid;
  grid-gap: 50px 25px;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 40px 25px;
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 40px 25px;
  }
  &.cs_list_view_wrap {
    grid-template-columns: repeat(1, 1fr);
  }
  &.cs_grid_view_wrap {
    .cs_team.cs_style_1.cs_type_2 {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
.cs_isotop_filter.cs_style1 {
  text-transform: capitalize;
}
.cs_pagination_box {
  .cs_pagination_item,
  .cs_pagination_arrow {
    border: none;
    &:hover {
      color: $accent;
    }
  }
  .cs_pagination_arrow {
    background-color: transparent;
  }
}
.form-check .form-check-input {
  border-color: #636363;
}
.cs_related_doctor .slick-dots {
  display: flex !important;
}
.react-datepicker-wrapper {
  display: block;
}
.cs_blog_grid_1 {
  display: grid;
  grid-gap: 20px 130px;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: 1700px) {
    grid-gap: 20px 80px;
  }
  @media (max-width: 1400px) {
    grid-gap: 20px;
  }
  @media (max-width: 991px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (min-width: 992px) {
    > * {
      grid-column: span 2;
      &:first-child {
        grid-row: span 3;
      }
    }
  }
}
.cs_error {
  padding: 80px 0;
  min-height: 100vh;
}
.cs_nav .cs_nav_list .cs_munu_dropdown_toggle.active + ul {
  display: block;
}
input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-calendar-picker-indicator,
input[type='time']::-webkit-inner-spin-button,
input[type='time']::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}
/*
* Personalizado
*/


.gl-section h2{
  color: #e866a2;
  font-family: "Montserrat", Sans-serif;
  font-size: 30px;
  font-weight: 800;
  line-height: 2rem;
  margin-top: 20px;
}
.gl-section h3{
  font-family: "Montserrat", Sans-serif;
  font-size: 26px;
  line-height: 26px;
}
/*.gl-section{
  padding: 0px!important;
}*/
.gl-text-container{
  padding-left: 0px!important;
  padding-right: 0px!important;
  padding-bottom: 20px!important;

}
.gl-container .gl-text-container{
  color:#54595f!important;
  font-family: "Montserrat", Sans-serif!important;
  text-align: justify;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.4em;
}
.gl-container img{
  margin-bottom: 20px;
  //width: 100%!important;
}

@media (min-width: 992px) {
  .gl-section:first-child {
    flex-basis: 55%!important;
  }

  .gl-section:last-child {
    flex-basis: 40%!important;
  }
}

//Formulario Style 1
.gl-section span{
  padding: 0px!important;
  border: 0px!important;
}
.gl-section section{
  height: 98%;
}

.form-style-1-container {
  position: -webkit-sticky;
  position: sticky;
  top: 200px;

}

.form-style-1 {
  display: flex;
  flex-direction: column;
}

.gl-container .gl-section:first-child {
  padding-right: 30px;
}

.gl-container .gl-section:nth-child(2) {
  padding-left: 30px;
  padding-top: 0px!important;
}
.form-header{
  background-color: transparent;
  background-image: linear-gradient(35deg, #D27EBC, #78ABCF);
  border-radius: 1rem 1rem 0rem 0rem;
  padding: 15px;
  padding-bottom: 1px;
}
.form-header h3{
  margin: 0 0 10px 0;
  color: #ffffff!important;
  font-size: 22px!important;
  font-weight: 800!important;
  line-height: 1.5rem!important;
}
.form-header p{
  color: #ffffff;
  font-family: "Open Sans", Sans-serif!important;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2em;
}
.form-body{
  background-color: transparent;
  background-image: linear-gradient(35deg, #F7B0D7, #B8D0E4);
  border-radius: 0rem 0rem 1rem 1rem;
  padding: 16px;
}
.form-style-1 button{
  background-image: linear-gradient(35deg, #DC89C3, #B29ECB);
  padding: 12px 12px 12px 12px;
  font-family: "Open Sans", Sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #ffffff;
  background-color: transparent;
  border-style: none;
  border-radius: 15px 15px 15px 15px;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.5);
  width: 100%;
}
.form-body .hide-label{
  display: none;
}
.form-body input, .form-body select{
  background-color: #FFFFFF80;
}
.form-group{
  font-size: 16px;
  margin-bottom: 15px;
}
.form-group input.form-control{
  background-color: #ffffff;
  border-radius: 15px;
}
.form-group .selected-flag{
  background-color: #ffffff!important;
}
.react-tel-input .form-control{
  width: 100%;
}
.form-control{
  padding: .282rem .75rem;
}
.checkbox-group{
  color: #ffffff;
}
.checkbox-option input{
  margin-right: 10px;
}
.form-group .telefono-input{
  border-radius: 15px;
}
.form-group .selected-flag, .form-group .flag-dropdown {
  border-radius: 15px 0px 0px 15px;
}
.form-group input{
  border: none;
}
.cs_hero.cs_style_1{
  margin-left: -3px;
}
.cs_site_header.cs_style1.cs_sticky_header.cs_heading_color ul li a{
  color:#ffffff;
}

.cs_site_header.cs_style1.cs_sticky_header.cs_heading_color .menu-item-has-children ul li a{
  color:#274760;
}
.cs_site_header.cs_style1.cs_sticky_header.undefined nav > ul > li a{
  color: #fff;
}
.cs_site_header.cs_style1.cs_sticky_header.cs_active_sticky nav > ul > li a{
  color: #274760;
}
#root > header > div > div > div > div.cs_main_header_left > nav > ul > li > ul > li > a{
  color: #274760;
}


.cs_department_list {
  overflow: hidden;
  width: 100%;
}

.form-body-two{
  background-color: #D5A1CC;
  // background-image: linear-gradient(35deg, #F7B0D7, #B8D0E4);
  border-radius: 1rem 1rem 1rem 1rem;
  padding: 16px;
}

.form-body-three{
  background-color: #B8AFD2;
  // background-image: linear-gradient(35deg, #F7B0D7, #B8D0E4);
  border-radius: 1rem 1rem 1rem 1rem;
  padding: 16px;
}

.form-body-four{
  background-color: #A7B7D5;
  // background-image: linear-gradient(35deg, #F7B0D7, #B8D0E4);
  border-radius: 1rem 1rem 1rem 1rem;
  padding: 16px;
}

.conference-btn-one{
  background-color: #D5A1CC;
  border: solid 1px;
  border-radius: 1rem;
  color: #ffffff;
  padding: 5px;
  width: 95%;
}

.conference-btn-one:hover {
  background-color: #B78BB2; /* Color más oscuro */
  border-color: #9C6D9A; /* Borde más oscuro */
}

.conference-btn-two{
  background-color: #B8AFD2;
  border: solid 1px;
  border-radius: 1rem;
  color: #ffffff;
  padding: 5px;
  width: 95%;
}

.conference-btn-two:hover {
  background-color: #9E98C2; /* Color más oscuro */
  border-color: #7E7DAF; /* Borde más oscuro */
}

.conference-btn-three{
  background-color: #A7B7D5;
  border: solid 1px;
  border-radius: 1rem;
  color: #ffffff;
  padding: 5px;
  width: 95%;
}

.conference-btn-three:hover {
  background-color: #8E9DC3; /* Color más oscuro */
  border-color: #7589A6; /* Borde más oscuro */
}

.btn-container-panel{
  gap:20px; 
  display: flex;
}

.form-conf-title{
  color: #ffffff;
}

@media (min-width: 768px) and (max-width: 1199px) {
  .cs_menu_toggle{
    color: #274760;
  }
  div.cs_main_header_left > nav > ul > li > a{
    color: #274760!important;
  }
}

@media (max-width: 767px) {
  .cs_menu_toggle{
    color: #274760;
  }
  div.cs_main_header_left > nav > ul > li > a{
    color: #274760!important;
  }
  footer .row{
    flex-wrap: wrap;
  }
  .gl-container{
    padding-left: 16px!important;
  }
  .gl-container h2{
    font-size: 24px;
    line-height: 24px;

  }
  .gl-container h3{
    font-size: 22px;
    line-height: 22px;
    margin-top: 20px;
  }
  .gl-container h4{
    font-size: 20px;
    line-height: 20px;
    margin-top: 20px;
  }
  .gl-container .form-style-1-container{
    position: static;
    padding-right: 20px;
    background-color: #ffffff;
  }
  .gl-section section{
    height: 100%;
  }
  .cs_footer.cs_style_1 .cs_footer_logo_wrap {
    height: calc(100%);
  }
  .cs_footer.cs_style_1 .cs_footer_main{
    padding: 20px 0;
  }
  footer .col-lg-2{
    width: 50%;
  }
  .cs_footer.cs_style_1 .cs_text_widget + .cs_contact_widget{
    margin-top: 20px;
  }
  .cs_footer.cs_style_1 {
    margin-top: 40px;
  }
  .cs_footer.cs_style_1.cs_heading_color{
    margin-top: 0px;
  }

  .gl-container .gl-section:nth-child(2) {
    padding-left: 10px;
  }
}

.row>* {
  flex-shrink: inherit;
}

#root{
  margin-left: -3px;
}
.img-mapas{
  width: 45px!important;
}

.language-switch {
  color: white;
}

.text-white{
  color: white
}


.whats_buttom {

	display: block;

	width: 60px;

	height: 60px;

	position: fixed;

	background-image: url("https://cdn.gestlifesurrogacy.com/img/whatsapp_buttom.svg");

	background-repeat: no-repeat;

	z-index: 99;

	bottom: 18px;

	right: 18px;

	animation: whatsapp 4s linear infinite;

}

.contact-methods-container {
  display: flex;
  justify-content: center; /* Centra los elementos horizontalmente */
  align-items: center; /* Centra los elementos verticalmente */
  gap: 10rem;
}

.contact-item-1{
  text-align: center;
  width: 10rem;
  

}

.contact-image-1{
  border-radius: 15px;
  background-color: #d5a1cc;
  margin-bottom: 1rem;
  width: 80%;
  padding: 1.5rem;
}

.contact-item-2{
  text-align: center;
  width: 10rem;
  
}

.contact-image-2{
  border-radius: 15px;
  background-color: #c5a8cf;
  margin-bottom: 1rem;
  width: 80%;
  padding: 1.5rem;

}

.contact-item-3{
  text-align: center;
  width: 10rem;
  
  
}

.contact-image-3{
  border-radius: 15px;
  background-color: #b8afd2;
  margin-bottom: 1rem;
  width: 80%;
  padding: 1.5rem;
}

.contact-item-4{
  text-align: center;
  width: 10rem;


}

.contact-image-4{
  border-radius: 15px;
  background-color: #a7b7d5;
  margin-bottom: 1rem;
  width: 80%;
  padding: 1.5rem;
}






.modern-text {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1px;
  color: #4a4a49;

}

.pop1 {
  font-size: 16px; /* Tamaño adecuado para los títulos */
  font-weight: 400;
  margin-bottom: 5px; /* Un pequeño margen debajo */

}

.pop2 {
  font-size: 14px; /* Tamaño de texto más pequeño */
  color: #4a4a49; /* Color más suave para el subtítulo */
  font-weight: 600;
}

/* Media query para pantallas más pequeñas */
@media (max-width: 768px) {

  .contact-methods-container {
    gap: 1.5rem; /* Reduce el espacio entre elementos en pantallas más pequeñas */
  }

  .contact-item-1 {
    width: 4rem; /* Ajuste de tamaño para pantallas pequeñas */
  }
  
  .contact-item-2 {
    width: 4rem; /* Ajuste de tamaño para pantallas pequeñas */
  }
  
  .contact-item-3 {
    width: 4rem; /* Ajuste de tamaño para pantallas pequeñas */
  }
  
  .contact-item-4 {
    width: 4rem; /* Ajuste de tamaño para pantallas pequeñas */
  }

  .contact-image-1{
    width: 100%;
  }
  .contact-image-2{
    width: 100%;
  }
  .contact-image-3{
    width: 100%;
  }
  .contact-image-4{
    width: 100%;
  }
  
  

  .pop1 {
    font-size: 10px; /* Reducir tamaño de los títulos */
  }

  .pop2 {
    font-size: 9px; /* Reducir tamaño de los subtítulos */
  }
}

.table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.radio-group {
  margin-top: 20px;
}

.radio-group h6{
  font-size: 16px;
  margin-bottom: 10px;
  color: white
}

.radio-group div {
  margin-bottom: 5px;
}


.radio-group label {
  display: inline-block;
  color: white;
  margin-left: 2px;
}

.accept-label{
  font-size: 14px;
  margin-left: 2px;
}

.notice-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8); /* Fondo oscuro */
  color: white;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.notice-banner-content {
  text-align: center;
  padding: 20px;
  max-width: 600px;
}

.notice-banner h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #EE6FBB;
}

.notice-banner p {
  font-size: 1rem;
  margin-bottom: 20px;
}

.notice-banner-links a {
  display: inline-block;
  margin: 10px 15px;
  padding: 10px 20px;
  background-color: #EE6FBB;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
}

.notice-banner-links a:hover {
  background-color: #7BADD3;
}

.flag-icon {
  width: 20px; /* Ajusta el tamaño de la bandera */
  height: auto;
  margin-right: 10px; /* Espacio entre la bandera y el texto */
}

.spain_text{
  background: linear-gradient(40deg, #EE6FBB, #7BADD3);
  min-height: 100vh;
  
}

.spain_text_content{
  display: flex;
  flex-direction: column;
  color:white;

}

.spain_text_title{
  color: white;
  display: flex;
  justify-content: center;
  font-size: 3rem;  /* Tamaño grande para pantallas más grandes */
  word-wrap: break-word;  /* Asegura que el texto se ajuste si es demasiado largo */
  overflow-wrap: break-word;  /* Opcional, pero útil para prevenir desbordes */
  padding: 0 20px;
}


.spain_text_container{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 100px;
}


@media (max-width: 768px) {

  .spain_text_container {
    padding: 50px 20px;  /* Reducir padding en pantallas medianas */
    width: 90%; /* Reducir el ancho máximo */
  }
  .spain_text_title {
    font-size: 1.5rem;  /* Reducir el tamaño del texto en pantallas más pequeñas */
    padding: 0 10px;
  }

}

/* Media query para pantallas muy pequeñas (móviles en apaisado o teléfonos pequeños) */
@media (max-width: 480px) {

  .spain_text_container {
    padding: 70px 10px;  /* Mucho menos padding para pantallas pequeñas */
    width: 100%;  /* El contenedor ocupa todo el ancho disponible */
    box-sizing: border-box; /* Asegura que el padding no afecte el ancho */
  }
  .spain_text_title {
    font-size: 1.2rem;  /* Aún más pequeño para pantallas más pequeñas */
  }
  .spain_text {
    padding: 10px; /* Ajusta el padding si es necesario */
  }
  
}


.margin_legalt{
  padding:150px;
}
@media (max-width: 680px) {
  .margin_legalt{
    padding:20px;
    margin-top: 100px;
  }
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

:root {
  @if $font-size-root != null {
    @include font-size(var(--#{$prefix}root-font-size));
  }

  @if $enable-smooth-scroll {
    @media (prefers-reduced-motion: no-preference) {
      scroll-behavior: smooth;
    }
  }
}

body {
  margin: 0;
  font-family: var(--#{$prefix}body-font-family);
  @include font-size(var(--#{$prefix}body-font-size));
  font-weight: var(--#{$prefix}body-font-weight);
  line-height: var(--#{$prefix}body-line-height);
  color: var(--#{$prefix}body-color);
  text-align: var(--#{$prefix}body-text-align);
  background-color: var(--#{$prefix}body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba($black, 0);
}

hr {
  margin: $hr-margin-y 0;
  color: $hr-color;
  border: 0;
  border-top: $hr-border-width solid $hr-border-color;
  opacity: $hr-opacity;
}

%heading {
  margin-top: 0;
  margin-bottom: $headings-margin-bottom;
  font-family: $headings-font-family;
  font-style: $headings-font-style;
  font-weight: $headings-font-weight;
  line-height: $headings-line-height;
  color: var(--#{$prefix}heading-color);
}

h1 {
  @extend %heading;
  @include font-size($h1-font-size);
}

h2 {
  @extend %heading;
  @include font-size($h2-font-size);
}

h3 {
  @extend %heading;
  @include font-size($h3-font-size);
}

h4 {
  @extend %heading;
  @include font-size($h4-font-size);
}

h5 {
  @extend %heading;
  @include font-size($h5-font-size);
}

h6 {
  @extend %heading;
  @include font-size($h6-font-size);
}

p {
  margin-top: 0;
  margin-bottom: $paragraph-margin-bottom;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: $dt-font-weight;
}

dd {
  margin-bottom: .5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: $font-weight-bolder;
}

small {
  @include font-size($small-font-size);
}

mark {
  padding: $mark-padding;
  color: var(--#{$prefix}highlight-color);
  background-color: var(--#{$prefix}highlight-bg);
}

sub,
sup {
  position: relative;
  @include font-size($sub-sup-font-size);
  line-height: 0;
  vertical-align: baseline;
}

sub { bottom: -.25em; }
sup { top: -.5em; }

a {
  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));
  text-decoration: $link-decoration;

  &:hover {
    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);
    text-decoration: $link-hover-decoration;
  }
}

a:not([href]):not([class]) {
  &,
  &:hover {
    color: inherit;
    text-decoration: none;
  }
}

pre,
code,
kbd,
samp {
  font-family: $font-family-code;
  @include font-size(1em);
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  @include font-size($code-font-size);
  color: $pre-color;

  code {
    @include font-size(inherit);
    color: inherit;
    word-break: normal;
  }
}

code {
  @include font-size($code-font-size);
  color: var(--#{$prefix}code-color);
  word-wrap: break-word;

  a > & {
    color: inherit;
  }
}

kbd {
  padding: $kbd-padding-y $kbd-padding-x;
  @include font-size($kbd-font-size);
  color: $kbd-color;
  background-color: $kbd-bg;
  @include border-radius($border-radius-sm);

  kbd {
    padding: 0;
    @include font-size(1em);
    font-weight: $nested-kbd-font-weight;
  }
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: $table-cell-padding-y;
  padding-bottom: $table-cell-padding-y;
  color: $table-caption-color;
  text-align: left;
}

th {
  font-weight: $table-th-font-weight;
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  @include font-size(inherit);
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role="button"] {
  cursor: pointer;
}

select {
  word-wrap: normal;

  &:disabled {
    opacity: 1;
  }
}

[list]:not([type="date"]):not([type="datetime-local"]):not([type="month"]):not([type="week"]):not([type="time"])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;

  @if $enable-button-pointers {
    &:not(:disabled) {
      cursor: pointer;
    }
  }
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: $legend-margin-bottom;
  @include font-size($legend-font-size);
  font-weight: $legend-font-weight;
  line-height: inherit;

  + * {
    clear: left;
  }
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}



`;

export default function Header({ logoSrc, variant }) {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const menuToggleRef = useRef(null);
  // Cargamos los datos del menú de forma estática desde el JSON generado en el build
  const [menuItems] = useState(menuData);
  const { pathname } = useLocation();
  const { translations } = useContext(TranslationContext);
  const { currentBlogArticle } = useContext(BlogArticleContext);
  const { t } = useTranslation();

  // Función para obtener el idioma actual a partir de la URL
  const getCurrentLanguage = () => {
    const pathSegments = pathname.split('/').filter(Boolean);
    const lang = pathSegments[0];
    const supportedLanguages = languages.map((l) => l.code);
    return supportedLanguages.includes(lang) ? lang : 'es';
  };

  const currentLanguage = getCurrentLanguage();

  // Asegurarse de que la ruta tenga barra final
  const ensureTrailingSlash = (path) => {
    if (!path) return '/';
    if (path.includes('#') || path.includes('/#')) {
      return path.replace(/\/+$/, '');
    }
    return path.endsWith('/') ? path : `${path}/`;
  };

  // Sanitizar el slug eliminando barras finales
  const sanitizeSlug = (slug) => {
    return slug ? slug.replace(/\/+$/, '') : '';
  };

  // Control del sticky header según el scroll
  useEffect(() => {
    const handleScroll = () => {
      const isCurrentlySticky = window.scrollY > 0;
      if (isSticky !== isCurrentlySticky) {
        setIsSticky(isCurrentlySticky);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isSticky]);

  useEffect(() => {
    const toggleEl = menuToggleRef.current;
    if (!toggleEl) return;
    const handleToggle = () => setMobileToggle((prev) => !prev);
    toggleEl.addEventListener('click', handleToggle);
    return () => toggleEl.removeEventListener('click', handleToggle);
  }, []);

  // Filtrar y adaptar el menú según el idioma currente
  const filteredMenuItems = menuItems
    .map((item) => {
      const normalizedCurrentLanguage = currentLanguage.toLowerCase().replace('_', '-');
      const itemLocale = item.locale.toLowerCase().replace('_', '-');
      if (itemLocale === normalizedCurrentLanguage) return item;

      const translation = item.translations.find(
        (t) => t.locale.toLowerCase().replace('_', '-') === normalizedCurrentLanguage
      );
      if (translation) {
        return {
          ...item,
          ...translation,
          slug: translation.slug || item.slug,
          name: translation.name || item.name,
        };
      }
      return null;
    })
    .filter(Boolean);

  // Construir el árbol del menú
  const buildMenuTree = (items, parentId = null) => {
    const filteredItems = items.filter((item) => item.parent_id === parentId);
    return filteredItems.map((item) => ({
      ...item,
      slug: sanitizeSlug(item.slug),
      children: buildMenuTree(items, item.id),
    }));
  };

  // Renderizar los elementos del menú
  const renderMenuItems = (items) => {
    const sortedItems = [...items].sort((a, b) => a.lft - b.lft);
    return sortedItems.map((item) => {
      const sanitizedSlug = sanitizeSlug(item.slug || item.link || '#');
      const basePath = `/${sanitizedSlug}`;
      const itemLink = ensureTrailingSlash(basePath);
      const isAnchorLink = itemLink.includes('#');
      return (
        <li key={item.id} className={item.children.length > 0 ? 'menu-item-has-children' : ''}>
          {isAnchorLink ? (
            <a
              href={itemLink}
              onClick={(e) => {
                e.preventDefault();
                setMobileToggle(false);
              }}
            >
              {item.name || 'Sin título'}
            </a>
          ) : (
            <Link to={itemLink} onClick={() => setMobileToggle(false)}>
              {item.name || 'Sin título'}
            </Link>
          )}
          {item.children.length > 0 && (
            <DropDown>
              <ul>{renderMenuItems(item.children)}</ul>
            </DropDown>
          )}
        </li>
      );
    });
  };

  const menuTree = buildMenuTree(filteredMenuItems);

  const filteredLanguages = pathname.includes('/blog')
    ? languages.filter((lang) => lang.code !== 'en-au')
    : languages;

  const isBlogArticlePage = pathname.includes('/blog/') && currentBlogArticle;
  const translationsToUse = isBlogArticlePage ? currentBlogArticle.translations : translations;

  const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16">
    <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"/>
  </svg>
);

const WhatsappIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16">
    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
  </svg>
);

const EnvelopeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16" style={{ verticalAlign: 'middle', display: 'inline-block' }}>
    <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/>
  </svg>
);

// Estilo inline para iconos en cabecera (depende del JS, no del CSS externo)
const inlineIconStyle = { display: 'inline-block', marginRight: '0.5rem', verticalAlign: 'middle' };

  // Detectar vista móvil (<768px)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Inyectar el CSS solo una vez
  useEffect(() => {
    if (!document.getElementById('header-inline-style')) {
      const style = document.createElement('style');
      style.id = 'header-inline-style';
      style.innerHTML = headerCSS;
      document.head.appendChild(style);
    }
  }, []);

  return (


   
    <header
      style={{ 
        position: 'sticky', 
        top: 0, 
        zIndex: 1000, 
        width: '100%',
        transition: 'all 0.3s ease'
      }}
      className={`cs_site_header cs_style1 cs_sticky_header ${
        mobileToggle ? 'cs_mobile_toggle_active' : ''
      } ${variant} ${isSticky ? 'cs_active_sticky' : ''}`}
    >
      <div className={`header-line ${isSticky ? 'sticky-line' : ''}`}>
        <span className="phone-number">
          <a href="tel:+302112340748" target="_blank" rel="noopener noreferrer">
            <div className="phone-location d-none d-md-block">{t('europe_phone')}</div>
            <div className="phone-info">
                <span className="icon_header" style={inlineIconStyle}><PhoneIcon /></span>
              <span className="phone-number-text"> +302112340748</span>
              <div className="phone-location d-none d-md-block">{t('free_call')}</div>
            </div>
          </a>
        </span>
        <span className="phone-number">
          <a href="tel:+13054041866" target="_blank" rel="noopener noreferrer">
            <div className="phone-location d-none d-md-block">America</div>
            <div className="phone-info">
                <span className="icon_header" style={inlineIconStyle}><PhoneIcon /></span>
              <span className="phone-number-text">+13054041866</span>
              <div className="phone-location d-none d-md-block">{t('call_header')}</div>
            </div>
          </a>
        </span>
        <span className="phone-number">
          <a href="https://api.whatsapp.com/send?phone=302112340748" target="_blank" rel="noopener noreferrer">
            <div className="phone-location d-none d-md-block">{t('global_wsp')}</div>
            <div className="phone-info">
              <span className="icon_header" style={inlineIconStyle}><WhatsappIcon /></span>
              <span className="phone-number-text">+302112340748</span>
              <div className="phone-location d-none d-md-block">WhatsApp</div>
            </div>
          </a>
        </span>
        <span className="phone-number">
          <a href="mailto:info@gestlifesurrogacy.com" style={{ display: 'flex', alignItems: 'center' }}>
            <span className="icon_header" style={{ display: 'inline-flex', alignItems: 'center', marginRight: '0.5rem' }}><EnvelopeIcon /></span>
            <span>info@gestlifesurrogacy.com</span>
          </a>
        </span>
        <div className="cs_main_header_right">
          <LanguageSwitcher
            languages={filteredLanguages}
            translations={translationsToUse}
            currentLanguage={currentLanguage}
          />
        </div>
      </div>

      <div className="cs_main_header">
        <div className="container">
          <div className="cs_main_header_in">
            <div className="cs_main_header_left">
              <Link className="cs_site_branding" to={currentLanguage !== 'es' ? `/${currentLanguage}/` : '/'}>
                <img 
                  src={isSticky ? '/images/Logotipo_Color.svg' : logoSrc} 
                  alt="Logo" 
                  className="site-logo" 
                  fetchpriority="high"
                  width={isMobile ? 160 : 238}
                  height={isMobile ? 40 : 60}
                  style={{
                    width: isMobile ? '160px' : '268px',
                    height: isMobile ? '40px' : '60px',
                    transition: 'all 0.3s ease'
                  }}
                />
              </Link>
              <nav className="cs_nav">
                <ul className={mobileToggle ? 'cs_nav_list cs_active' : 'cs_nav_list'}>
                  {renderMenuItems(menuTree)}
                  {mobileToggle && (
                    <li className="menu-item">
                      <EmbajadorButton className="embajador-button-mobile" />
                    </li>
                  )}
                </ul>
                <span
                  ref={menuToggleRef}
                  className={mobileToggle ? 'cs_menu_toggle cs_toggle_active' : 'cs_menu_toggle'}
                >
                  <span></span>
                </span>
              </nav>
            </div>
            <div className="cs_main_header_right">
              {!mobileToggle && <EmbajadorButton className="embajador-button-header" />}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
